import React from 'react';
import { Input } from 'antd';

// Custom search icon
const SearchIcon = () => (
    <svg 
        width="20" 
        height="20" 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ pointerEvents: 'none' }}
    >
        <circle 
            cx="7" 
            cy="7" 
            r="5.5" 
            stroke="currentColor" 
            strokeWidth="1.5"
        />
        <path 
            d="M11 11L14.5 14.5" 
            stroke="currentColor" 
            strokeWidth="1.5" 
            strokeLinecap="round"
        />
    </svg>
);

// Custom clear icon
const ClearIcon = ({ onClick }) => (
    <svg 
        width="16" 
        height="16" 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
        style={{ cursor: 'pointer' }}
    >
        <circle cx="8" cy="8" r="7" fill="#666666" />
        <path 
            d="M5 5L11 11M11 5L5 11" 
            stroke="white" 
            strokeWidth="2" 
            strokeLinecap="round"
        />
    </svg>
);

const FilterInput = ({ 
    placeholder, 
    value, 
    onChange, 
    onEnter,
    allowClear = true,
    ...props 
}) => {
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && onEnter) {
            onEnter(e.target.value);
        }
    };

    const handleClear = () => {
        if (onChange) {
            onChange({ target: { value: '' } });
        }
    };

    // Hiển thị icon search khi không có text, hiển thị clear khi có text
    const suffixIcon = value && allowClear ? (
        <ClearIcon onClick={handleClear} />
    ) : (
        <SearchIcon />
    );

    return (
        <Input
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={handleKeyDown}
            allowClear={false}
            className="filter-input"
            suffix={suffixIcon}
            style={{
                height: '44px',
                lineHeight: '44px',
                padding: '0 8px',
                textAlign: 'center'
            }}
            {...props}
        />
    );
};

export default FilterInput;
